<template>
	<div class="trade">
	<div class="content">
		<!-- 标题 -->
    <comtitle title="交易详情" firstUrl="/index" firstUrlTitle="首页" secondUrl="/tradeList" secondUrlTitle="全部交易信息"></comtitle>
    <div class="h-title">
      <span></span><p>交易哈希</p>
    </div>
		<!-- 区块哈希 -->
		<div class="hash">
			<p>{{hash | addressEll }}</p>
		</div>
		<!-- 标题 -->
    <div class="h-title">
      <span></span><p>交易详情</p>
    </div>
		<div class="allcention" v-if="txNotFound">
			<p class="placeholder-result tc">
				未查询到交易信息，<span class="c-link" @click="txNotFound=false;getTradeDetail(hash)">重试</span>
			</p>
		</div>
		<!-- 概况 -->
		<div class="allcention" v-else>
			<ul class="cention">
				<li class="cli">
					<span>接收状态</span>
					<span>成功</span>	
				</li>
				<li class="cli">
					<span>区块高度</span>
					<router-link class="link" :to="{path:'/blockDetail', query:{'height':tradehInfo.block_number}}">{{tradehInfo.block_number}}</router-link>	
				</li>
				<li class="cli">
					<span>时间(GMT+8)</span>
					<p class="right-info">{{tradehInfo.timestamp | fulltime}}</p>	
				</li>
				<li class="cli">
					<span>来自</span>
					<div class="link auto right-info">
						<p class="link" @click="goAddress(tradehInfo.from)">{{tradehInfo.from}}</p>
					</div>
				</li>
				<li class="cli">
					<span>去向</span>
					<div class="link auto right-info">
						<p class="link" @click="goAddress(tradehInfo.to)">{{tradehInfo.to}}</p>
					</div>
				</li>
				<li class="cli" v-if="tradehInfo.kind === 0" >
					<span>价值</span>
					<p class="right-info">{{tradehInfo.value | formatValue}}</p>	
				</li>
				<li class="cli">
					<span>燃料费</span>
					<span>{{tradehInfo.gas|formatGas}}</span>	
				</li>
				<li class="cli">
					<span>随机数</span>
					<p class="right-info">{{tradehInfo.nonce|hexToNumberString}}</p>	
				</li>
				<li class="cli">
					<span>调用函数</span>
					<span>{{tradehInfo.method === ''? 'none':tradehInfo.method}}</span>	
				</li>
				<li class="cli">
					<span>交易类型</span>
					<p class="right-info">{{tradehInfo.kind === 0? '普通交易':'合约调用'}}</p>	
				</li>
				<li class="cli" v-if="tradehInfo.tokenId">
					<span>藏品Token</span>
					<p class="right-info">{{tradehInfo.tokenId === ''? 'none':tradehInfo.tokenId}}</p>	
				</li>
				<li class="cli"  v-if="tradehInfo.imageUri">
					<span>藏品</span>
					<a :href="tradehInfo.imageUri" target="_blank">
                     <img :src="tradehInfo.imageUri" style="width:150px;padding:5px" alt="">
                    </a>
				</li>
				<li class="cli"  v-if="tradehInfo.name">
					<span>藏品名称</span>
					<p class="right-info">{{tradehInfo.name === ''? 'none':tradehInfo.name}}</p>	
				</li>
				<li class="mian cli" v-if="tradehInfo.description != ''">
					<span class="hundred">藏品描述</span><br>
					<div class="kuai">
						<p>{{tradehInfo.description}}</p>
					</div>
				</li>
			</ul>
			<div class="writesdata" id="writesdata" v-if="tradehInfoTx.execer == 'user.write'">
				<markdown :content="markdownContent"></markdown>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
import comtitle from "@/components/comtitle.vue";
import tradeHashBase from "./tradeHash.base.js";
export default {
  components: {
    comtitle,
    markdown: () => import("@/components/markdown"),
  },
  mixins: [tradeHashBase],
};
</script>
<style lang="scss">
.trade {
  .content {
    padding: 0 3vw 5vw;
    .h-title {
      height: 10vw;
      line-height: 10vw;
      // background: #ccc;
      span {
        // float: left;
        border-left: 0.5vw solid #838b9e;
      }
      p {
        // float: left;
        font-size: 4.5vw;
        display: inline-block;
        margin-left: 3vw;
      }
    }
  }
  .hash {
    /*width: 100%;*/
    height: 10vw;
    background: #fff;
    padding: 0 2vw;
    overflow-x: auto;
    p {
      white-space: nowrap; /*强制span不换行*/
      overflow-x: scroll;
      line-height: 10vw;
      color: #5d6187;
      font-size: 3.5vw;
    }
  }
  .hash::-webkit-scrollbar {
    display: none;
  }
  .allcention {
    background: #fff;
    // border:1px solid #eee;
    box-shadow: rgba(229, 235, 243, 1) 0 0 3vw;
    .cli {
      min-height: 44px;
      line-height: 44px;
      border-bottom: 1px solid #eee;
      span:nth-of-type(1) {
        float: left;
        display: block;
        height: 44px;
        overflow-x: auto;
        max-width: 200px;
        width: 30%;
      }
      span {
        padding-left: 13px;
      }
      .right-info {
        float: left;
        margin-left: 13px;
      }
      .auto {
        white-space: nowrap;
        float: left;
        display: block;
        height: 44px;
        overflow-y: auto;
        max-width: 200px;
        width: 60%;
        // margin-left: 13px;
      }
      .auto::-webkit-scrollbar {
        display: none;
      }
      .link {
        color: #0975a7;
      }
      span:nth-of-type(1) {
        color: #838b9e;
      }
      a {
        width: 60%;
        padding-left: 13px;
      }
    }

    .mian {
      height: auto;
      padding-bottom: 10px;
      .kuai {
        /*width: 100%;*/
        height: 230px;
        padding: 10px;
        margin: 0 13px;
        background: #f9f9f9;
        border: 1px solid #eee;
        color: #6e6e6e;
        word-wrap: break-word;
        overflow-y: auto;
        white-space: pre-line;
        line-height: 20px;
        /*overflow: auto;*/
        p {
          width: 100%;
          pre {
            width: 100%;
            white-space: pre-wrap;
            word-wrap: break-word;
          }
        }
      }
    }
  }
  #writesdata {
    width: auto;
    overflow: hidden;
    padding: 10px;
    h1 {
      font-weight: 700;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      span {
        width: 0;
      }
      a {
        display: block;
        text-align: left;
        width: 100%;
      }
    }
    li {
      border: 0;
      overflow: hidden;
      height: auto;
      line-height: 30px;
    }
    img {
      max-width: 100%;
    }
  }
}
</style>